<template>
  <div class="md:container">
    <a-form :form="form" @submit.prevent="handleMatter" autocomplete="off">
      <div class="flex flex-col md:flex-row">
        <div class="w-full md:w-1/5">
          <h4 class="text-gray-900 text-lg">Add Matter</h4>
        </div>
        <div class="w-full md:w-4/5">
            <vx-card title="Matter information" class="md:p-3">
              <div class="grid md:grid-cols-2 lg:grid-cols-2 sm:grid-cols-1 md:gap-10">
                <div>
                  <a-form-item label="Title" has-feedback>
                    <a-input
                      v-decorator="['title',{ rules: [{ required: true, message: 'Please Enter title field.' }] }]"
                      placeholder="title"
                      autocomplete="none"
                      class="ant-input"
                    />
                  </a-form-item>
                  <SelectSearch @click="handleCreateClient" ref="client" :options="{ field:'client',label:'Client',is_add_extra_footer:true }" :required="true" @selectSearch="changeSelectSearch"/>
                  <a-form-item label="Matter description" has-feedback>
                    <a-textarea
                      v-decorator="['description',{ rules: [{ required: true, message: 'Please input your description!' }] }]"
                      style="height: 120px"
                      autocomplete="none"
                    />
                  </a-form-item>
                  <SelectOption url="/account/list/" label="Responsible Lawyer" placeholder="Responsible" field="responsible" method="get" mode="multiple"/>
                  <SelectOption url="/account/list/" label="Originating Lawyer" placeholder="Originating" field="origination" method="get" mode="multiple"/>
<!--                  <a-form-item label="Client reference number" has-feedback>-->
<!--                    <a-input-->
<!--                      v-decorator="['reference_code',{rules: [{ required: false }] }]"-->
<!--                      placeholder="reference"-->
<!--                      class="ant-input"-->
<!--                      autocomplete="none"-->
<!--                    />-->
<!--                  </a-form-item>-->
                  <a-form-item label="Location" has-feedback>
                    <a-input
                      v-decorator="['location',{ rules: [{ required: false }] }]"
                      placeholder="Location"
                      class="ant-input"
                      autocomplete="none"
                    />
                  </a-form-item>
                </div>
                <div>
                  <SelectOption
                    ref="groups"
                    url="/account/group/"
                    label="Group"
                    field="group"
                    placeholder="Groups"
                    method="get"
                    :required="false"
                    @SelectUser="selectGroup"
                  />
                  <SelectOption ref="practice_area" @emitClicker="emitClicker" url="/dictionary/practice-area/" :is_add_extra_footer="true" label="Practice Area" placeholder="Practice Area" field="practice_area" :required="true" method="get"/>
                  <a-form-item label="Status" has-feedback>
                    <a-select
                      placeholder="Status"
                      style="width: 100%"
                      allowClear
                      class="select"
                      v-decorator="['status',{ initialValue: '1',rules: [{ required: false }] }]"
                    >
                      <a-select-option value="1">
                        Open
                      </a-select-option>
                      <a-select-option value="2">
                        Closed
                      </a-select-option>
                      <a-select-option value="3">
                        Pending
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <div class="flex flex-col md:flex-row md:space-x-6" style="margin-top:4px">
                    <a-form-item label="Opened date" has-feedback>
                      <a-date-picker
                        v-decorator="['open_date',{ rules: [{ required: false, message: 'Please input your username!' }] }]"
                        :format="dateFormat"
                        valueFormat="YYYY-MM-DD"
                        class="w-full"
                      />
                    </a-form-item>
                    <a-form-item label="Closed date" has-feedback>
                      <a-date-picker
                        v-decorator="['closed_date',{ rules: [{ required: false, message: 'Please input your username!' }] }]"
                        :format="dateFormat"
                        valueFormat="YYYY-MM-DD"
                        class="w-full"
                      />
                    </a-form-item>
                  </div>
<!--                  <a-form-item v-show="false" label="Pending date" has-feedback>-->
<!--                    <a-date-picker-->
<!--                      v-decorator="['pending_date',{ initialValue:null,rules: [{ required: false, message: 'Please input your username!' }] }]"-->
<!--                      :format="dateFormat"-->
<!--                      valueFormat="YYYY/MM/DD"-->
<!--                      class="w-full md:w-1/2"-->
<!--                    />-->
<!--                  </a-form-item>-->

                  <!-- The following <p> is commented because we might want it later on -->
                  <!-- <p class="font-semibold" style="margin-top: 45px !important;">Statute of limitation</p> -->
                  <div class="flex flex-col xl:flex-row xl:space-x-6 items-start">
                    <a-form-item label="Limitation date" has-feedback>
                      <a-date-picker
                        v-decorator="['limitation_date',{rules: [{ required: active_Limitations, message: 'Please enter your limitation date.' }] }]"
                        placeholder="dd/mm/yyyy"
                        :disabled="!active_Limitations"
                        valueFormat="YYYY-MM-DD"
                        :format="dateFormat"
                        ref="limitation_date"
                      />
                    </a-form-item>
                    <a-form-item class="xl:self-end">
                      <a-checkbox
                        v-decorator="['is_limitation_date_satisfied',{ initialValue:false,valuePropName:'checked' }]"
                        @change="limitationDate"
                      >
                        Limitation date
                      </a-checkbox>
                    </a-form-item>
                  </div>
                </div>
              </div>
            </vx-card>
            <a-divider class="divider-matter"/>
            <vs-collapse type="margin">
              <vs-collapse-item
                class="contacts"
                :open="!!(editContact && rows.relations && rows.relations.length)"
              >
                <div slot="header">
                  <p class="text-sm md:text-xl font-bold mb-0 select-none" style="color: #3A3DBE; cursor: pointer;">
                    Related contacts
                  </p>
                </div>
                <p>
                  Associating a contact will allow you to easily locate their information from the matter dashboard.
                  These contacts will also appear in future conflict checks.
                </p>

                <div v-for="(relation,index) in relations">
                  <div class="grid grid-cols-1 md:grid-cols-3 md:gap-4">
                    <a-form-item v-show="false">
                      <a-input
                        v-decorator="[`relations[${index}].id`,{rules: [{ required: false }]}]"
                      />
                    </a-form-item>
                    <a-form-item label="Relationship" has-feedback>
                      <a-input
                        v-decorator="[`relations[${index}].relationship`,{ rules: [{ required: false, message: 'Please input your username!' }] }]"
                        autocomplete="none"
                        @change="onContactRelationshipChanged"
                      />
                    </a-form-item>
<!--                    <SelectSearch :options="{field:`relations[${index}].contact`,label:'Contacts'}" @selectSearch="changeSelectSearch"/>-->
                    <a-form-item label="Contacts" has-feedback>
                      <a-select
                        class="select"
                        show-search
                        :filter-option="filterOption"
                        v-decorator="[`relations[${index}].contact`,{rules: [{ required: form.getFieldValue(`relations[${index}].relationship`), message: 'Please input your username!' }] }]"
                        allowClear
                        @change="onContactContactsChanged"
                      >
                        <a-select-option v-for="item in contacts" :value="item.id">
                          <template v-if="item.person">
                            {{ item.person.first_name }} {{ item.person.last_name }}
                          </template>
                          <template v-else>
                            {{ item.company.name }}
                          </template>
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                    <a-button 
                      type="link"
                      icon="minus-circle"
                      class="p-0 self-center text-sm mt-4" style="color:#3A3DBE;width:35%"
                      @click="removeRelatedContact(index,relations,relation.id,related_content)"
                    >
                      Remove
                    </a-button>
                  </div>
                </div>

                <a-button 
                  type="link"
                  icon="plus-circle"
                  class="text-sm pl-0"
                  style="color: #3A3DBE;"
                  @click="onRelatedContactAdded"
                >
                  Add related contact
                </a-button>

              </vs-collapse-item>

              <!--              <a-divider/>-->

              <!--              <vs-collapse-item>-->
              <!--                <div slot="header">-->
              <!--                  <p class="text-xl font-bold mb-0" style="color:#3A3DBE;;">Custom Fields</p>-->
              <!--                </div>-->
              <!--                <p>-->
              <!--                  Speed up your workflow by <a href="">creating Custom Field sets</a> for commonly used Custom Fields-->
              <!--                </p>-->
              <!--                <a-form-item>-->
              <!--                  <a-select-->
              <!--                    placeholder="Add a Custom Field or Custom Field set"-->
              <!--                    allowClear-->
              <!--                    class="select w-1/2"-->
              <!--                    v-decorator="['Status',{ rules: [{ required: false, message: 'Please input your username!' }] }]"-->
              <!--                  >-->
              <!--                    <a-select-option value="1">-->
              <!--                      contact 1-->
              <!--                    </a-select-option>-->
              <!--                    <a-select-option value="2">-->
              <!--                      contact 2-->
              <!--                    </a-select-option>-->
              <!--                    <a-select-option value="3">-->
              <!--                      contact 3-->
              <!--                    </a-select-option>-->
              <!--                  </a-select>-->
              <!--                </a-form-item>-->
              <!--              </vs-collapse-item>-->

              <a-divider class="divider-matter"/>

              <vs-collapse-item
                class="billable"
                :open="true || !!(editContact && (rows.has_budget || rows.hourly_rates.length || rows.contingency_rates.length))"
              >
                <div slot="header">
                  <p class="text-sm md:text-xl font-bold mb-0 select-none" style="color:#3A3DBE; cursor: pointer">
                    Billing preferences
                    <small v-if="is_show_budget || check_billing_type === '2' || check_billing_type === '3'"
                      class="ml-4 font-medium"
                     style="color: red"
                    >
                      Required fields
                    </small>
                  </p>
                </div>
                <p>One or more billable matters can be used to create an invoice for a client.</p>

                <a-form-item>
                  <a-checkbox
                    v-decorator="['is_billable',{ initialValue:false,valuePropName:'checked' }]"
                    @change="onMatterIsBillableChanged"
                  >
                    Matter is billable
                  </a-checkbox>
                </a-form-item>

                <a-form-item has-feedback>
                  <a-select
                    allowClear
                    class="md:w-1/3 select"
                    v-decorator="['billing_type',{ initialValue: '1', rules: [{ required: false, message: 'Please input your username!' }] }]"
                    @select="handleSelectBillingType"
                  >
                    <a-select-option value="1">Hourly</a-select-option>
                    <!-- <a-select-option value="2">Contingency fee</a-select-option> --> <!-- OPTIONAL! DO NOT REMOVE -->
                    <a-select-option value="3">Fixed Fee</a-select-option>
                  </a-select>
                </a-form-item>

                <div v-show="check_billing_type === '2'">
                  <div class="grid grid-cols-1 md:grid-cols-2 md:w-2/3 md:gap-4">

                    <a-form-item v-show="false">
                      <a-input
                        v-decorator="[`contingency_rates[0].id` ,{ rules: [{ required: false }]}]"
                      />
                    </a-form-item>

                    <SelectOption
                      label="Firm users"
                      field="contingency_rates[0].user"
                      method="get"
                      :required="check_billing_type === '2'"
                      :is_initial_value="true"
                    />

                    <a-form-item label="Rate" has-feedback>
                      <a-input
                        class="rate_inp"
                        @keypress="onlyNumber"
                        @blur="convertToDecimal(`contingency_rates[0].rate`,form)"
                        addon-after="%"
                        v-decorator="[`contingency_rates[0].rate`,{ rules: [{ required: check_billing_type === '2', message: 'Select a valid rate.' }]}]"
                      />
                    </a-form-item>


                  </div>
                </div>
                <div v-show="check_billing_type === '3'">
                  <div class="grid grid-cols-1 md:grid-cols-2 md:w-2/3 md:gap-4">

<!--                    <a-form-item v-show="false">-->
<!--                      <a-input-->
<!--                        v-decorator="[`fixed_fee[0].id` ,{ rules: [{ required: false }]}]"-->
<!--                      />-->
<!--                    </a-form-item>-->

<!--                    <SelectOption-->
<!--                      label="Fee recipient"-->
<!--                      field="fixed_fee[0].user"-->
<!--                      method="get"-->
<!--                      :required="true"-->
<!--                    />-->


                    <a-form-item label="Amount" has-feedback>
                      <a-input
                        class="rate_inp"
                        @keypress="onlyNumber"
                        @blur="convertToDecimal(`fixed_fee`,form)"
                        addon-after="MR"
                        v-decorator="['fixed_fee',{ initialValue: null,rules: [{ required: check_billing_type === '3', message: 'Select a valid amount.' }]}]"
                        @change="onAmountChanged"
                      />
                    </a-form-item>


                  </div>
                </div>
                <div v-show="check_billing_type === '1'">
                  <div v-for="(hourly,index) in hourly_rates" :key="index" :value="hourly">

                    <div class="grid grid-cols-1 md:grid-cols-3 md:gap-4">


                      <a-form-item v-show="false">
                        <a-input
                          v-decorator="[`hourly_rates[${index}].id`,{ rules: [{ required: false }]}]"
                        />
                      </a-form-item>


                      <a-form-item label="Firm users" has-feedback>
                        <a-select
                          allowClear
                          class="select"
                          @change="handleChangeHourlyRates($event,`hourly_rates[${index}].user`)"
                          v-decorator="[`hourly_rates[${index}].user`,{ rules: [{ required: check_billing_type === '1', message: 'Select a valid firm user.' }] }]"
                        >
                          <a-select-option v-for="item in users" :disabled="selectedItem.includes(item.id)" :value="item.id">
                            {{ item.first_name }} {{ item.last_name }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                      <a-form-item label="Rate">
                        <a-input
                                  class="rate_inp"
                                  @keypress="onlyNumber"
                                  addon-after="/hr"
                                  @blur="convertToDecimal(`hourly_rates[${index}].rate`,form)"
                                  v-decorator="[`hourly_rates[${index}].rate`,{ rules: [{ required: check_billing_type === '1', message: 'Select a valid rate.' }]}]"
                        />
                      </a-form-item>

                      <a-button type="link"
                                  icon="minus-circle"
                                  class="p-0 md:ml-2 md:mt-8 justify-self-end md:justify-self-start text-sm"
                                  style="color:#3A3DBE"
                                  @click="removeCustomRate(index,hourly_rates,hourly.id,new_rate)"
                        >
                          Remove
                      </a-button>

                    </div>
                  </div>
                  <a-button type="link" icon="plus-circle" class="text-sm pl-0" style="color:#3A3DBE;" @click="onCustomRateAdded">
                    Add a custom rate
                  </a-button>
                </div>

                <p class="font-bold text-lg mt-5">Matter budget</p>
                <a-form-item>
                  <a-checkbox 
                    @change="handleChange"
                    v-decorator="['has_budget',{ initialValue: false, valuePropName: 'checked' }]"
                  >
                    Matter has a budget
                  </a-checkbox>
                </a-form-item>
                <div v-if="is_show_budget">
                  <div class="grid grid-cols-1 md:grid-cols-2 md:gap-4">
                    <a-form-item label="Budget" has-feedback>
                      <a-input 
                        autocomplete="none"
                        placeholder="0.00"
                        @keypress="onlyNumber"
                        @change="onMatterBudgetChanged"
                        v-decorator="['budget', { rules: [{ required: true, message: 'Select a valid amount.' }] }]"
                        prefix="$"
                      />
                    </a-form-item>
                    <a-form-item class="self-start mt-8">
                      <a-checkbox v-decorator="['has_notify',{ initialValue: false, valuePropName: 'checked' }]" @change="handleChangeNotifications">
                        Notify
                      </a-checkbox>
                    </a-form-item>
                    <template v-if="has_notify_budget">
                      <SelectOption 
                        url="/account/list/"
                        label="Notification recipients"
                        field="notifications"
                        method="get"
                        :required="true"
                        mode="multiple"
                        @change="onNotificationRecipientsChanged"
                      />
                      <a-form-item label="% Limit" has-feedback>
                        <a-input-number
                          :min="1"
                          :max="100"
                          autocomplete="none"
                          @change="onNotificationLimitChanged"
                          @keypress="onlyNumber"
                          v-decorator="['notify_limit',{ rules: [{ required: true, message: 'Select a valid amount.' }] }]"
                          style="width: 150px"
                        />
                      </a-form-item>
                    </template>
                  </div>
                </div>
              </vs-collapse-item>

              <!--              <a-divider/>-->

              <!--              <vs-collapse-item>-->

              <!--                <div slot="header">-->
              <!--                  <p class="text-xl font-bold mb-0" style="color:#3A3DBE;">Task automation</p>-->
              <!--                </div>-->

              <!--                <p>-->
              <!--                  <a href="">Create task lists</a> to automatically generate groups of commonly created tasks and assign them to a firm user.-->
              <!--                </p>-->

              <!--                <a-form-item label="Task list">-->
              <!--                  <a-select-->
              <!--                    placeholder="Find a task list "-->
              <!--                    allowClear-->
              <!--                    class="w-1/3 select"-->
              <!--                    v-decorator="['task',{ rules: [{ required: false, message: 'Please input your username!' }] }]"-->
              <!--                  >-->
              <!--                    <a-select-option value="1">-->
              <!--                      task 1-->
              <!--                    </a-select-option>-->
              <!--                    <a-select-option value="2">-->
              <!--                      task 2-->
              <!--                    </a-select-option>-->
              <!--                    <a-select-option value="3">-->
              <!--                      task 3-->
              <!--                    </a-select-option>-->
              <!--                  </a-select>-->
              <!--                </a-form-item>-->

              <!--                <a-button type="link" icon="plus-circle" class="text-sm pl-0" style="color:#3A3DBE;;">-->
              <!--                  Add a custom rate-->
              <!--                </a-button>-->

              <!--                <a-form-item>-->
              <!--                  <a-checkbox-->
              <!--                    v-decorator="['Notify',{ valuePropName:'checked' }]"-->
              <!--                  >-->
              <!--                    Notify firm users when matter trust funds are below-->
              <!--                  </a-checkbox>-->
              <!--                </a-form-item>-->

              <!--              </vs-collapse-item>-->

            </vs-collapse>

        </div>
      </div>
      <br>
      <br>
      <br>
      <Footer v-if="hasPermission('matter.edit')" class="matter-footer" url="/matters"/>
    </a-form>

    <a-modal title="Create New Client" :footer="null" :visible="open_create_client" @cancel="open_create_client = false" centered :width="1000">
      <ModalCreateClient @cancelClick="cancelClick" @addClient="addClient"/>
    </a-modal>

    <ModalPracticeArea ref="modal" :getPracticeArea="getPracticeArea" @createPracticeArea="createPracticeArea"/>

  </div>
</template>

<script>
import axios from "@/axios"
import SelectOption from "../forms/SelectOptionSingle"
import Mixin from '../mixin/mixin'
import SelectSearch from '../forms/selectSearch'
import Footer from "@/views/footer/Footer";
import ModalCreateClient from "./ModalCreateClient";
import ModalPracticeArea from '../pages/user-settings/system/modalpracticeArea/ModalPracticeArea'

export default {
  name: "addMatter",

  mixins: [Mixin],

  components: {
    SelectOption,
    SelectSearch,
    Footer,
    ModalCreateClient,
    ModalPracticeArea
  },

  data() {
    return {
      oldBillingPanelHeight      : null,
      oldContactsPanelHeight     : null,
      billingPanelResizeObserver : null,
      contactsPanelResizeObserver: null,
      contacts                   : [],
      users                      : [],
      relations                  : [],
      related_content            : [],
      rows                       : {},
      active_Limitations         : false,
      is_show_budget             : false,
      has_notify_budget          : false,
      check_billing_type         : '1',
      hourly_rates               : [],
      new_rate                   : [],
      value_select_search        : null,
      open_create_client         : false,
      selectedItem               : [],
      required_contact_relational: false
    }
  },

  methods: {
    selectGroup(id) {
      const groups = this.$refs.groups.data
      const findUsers = groups.find(group => group.id === id)
      if(findUsers !== undefined)
        this.form.setFieldsValue({ responsible: findUsers.users.map(item => item.id) })
    },
    handleChangeHourlyRates(value,oldVal){
      if(this.form.getFieldValue(oldVal)){
        this.selectedItem = this.selectedItem.filter(item=> item !== this.form.getFieldValue(oldVal))
        this.selectedItem.push(value)
      }else if(!this.selectedItem.includes(value)){
        this.selectedItem.push(value)
      }
    },
    async createPracticeArea(data){
      if(data){
        this.$refs.practice_area.data.push(data)
        this.form.setFieldsValue({ practice_area: data.id })
      }
    },
    emitClicker(){
      this.$refs.modal.visible = true
    },
    cancelClick(){
      this.open_create_client = false
    },
    async addClient(data){
      this.open_create_client = false
      if (data){
        this.$refs.client.rows.push(data)
        this.value_select_search = data.id
        this.form.setFieldsValue({ client: data.id })
      }
    },
    changeSelectSearch(val){
      this.value_select_search = val
    },
    handleCreateClient(){
      this.open_create_client = true
    },
    handleMatter() {
      this.form.validateFields(async (err, values) => {

        if (!values.title || !values.description || !values.client || !values.practice_area) {
          this.$message.error('Fields are required.');
          window.scroll({top: 0, behavior: 'smooth'});
          return
        }

        if (!err) {
          try {
            this.$vs.loading()
            if(values.contingency_rates[0].user === null){
              values.contingency_rates = []
            }

            if(!values.responsible){
              values.responsible = null
            }

            if(!values.origination){
              values.origination = null
            }

            (values.relations && values.relations.length) ? values.relations = values.relations.filter(item=>item.relationship && item.contact) : values.relations = []

            if (this.editContact) {
              this.value_select_search ? values.client = this.value_select_search : values.client = this.rows.client_id
              await axios.put(`matter/${this.$route.params.id}/`, values)
            } else {
              await axios.post('/matter/', values)
            }
            this.$notification['success']({
              message: 'Success',
              description:`Matter ${this.editContact ? 'updated' : 'created'}.`,
            });
            await this.$router.push('/matters')
            this.form.resetFields()
          } catch (e) {
            if (e.message === 'Network Error') {
              this.$notification['error']({
                message: 'Network Error',
                description:`Please try again.`
              });
            }
            if (e.status === 500){
              this.$notification['error']({
                message: 'Server Error',
                description:`Please try again.`
              });
            }

          } finally {
            this.$vs.loading.close()
          }
        }
      })
    },
    async editItem() {
      try {
        this.$vs.loading()
        const {data} = await axios.get(`/matter/${this.$route.params.id}/?random=${this.getRandomDigitsWords(15)}`)
        this.relations = data.relations
        if(data.relations.length){
          const relations = data.relations.map(item => ({id: item.id, contact: item.contact.id , relationship: item.relationship}))
          data.relations = relations
        }
        if(data.notifications.length){
          const notifications = data.notifications.map(item => item.id)
          data.notifications = notifications
        }
        if(data.hourly_rates && data.hourly_rates.length)
          this.selectedItem = data.hourly_rates.map(item=>item.user_id)
        data.status = `${data.status}`
        data.client_id = data.client.id
        data.client =  data.client.person ? `${data.client.person.first_name} ${data.client.person.last_name}` : `${data.client.company.name}`
        data.billing_type = `${data.billing_type}`
        if (data.practice_area) data.practice_area = data.practice_area.id
        if (data.responsible && data.responsible.length) data.responsible = data.responsible.map(item => item.id)
        if (data.origination && data.origination.length) data.origination = data.origination.map(item => item.id)
        if (data.group) data.group = data.group.id
        this.active_Limitations = data.is_limitation_date_satisfied
        if (!data.is_limitation_date_satisfied) data.limitation_date = undefined
        if (data.has_budget) this.is_show_budget = true
        this.has_notify_budget = data.has_notify
        if(data.hourly_rates && data.hourly_rates.length && data.billing_type === '1'){
          data.hourly_rates = data.hourly_rates.map(item=>({ id:item.id , user: item.user_id , rate: item.rate }))
          this.hourly_rates = data.hourly_rates
        }
        if(data.contingency_rates && data.contingency_rates.length && data.billing_type === '2'){
           this.check_billing_type = '2'
           data.contingency_rates = data.contingency_rates.map(item=>({ id:item.id , user: item.user_id , rate: item.rate }))
        }
        if(data.billing_type === '3' && data.fixed_fee){
          this.check_billing_type = '3'
        }
        this.rows = data
        this.$nextTick(() => this.form.setFieldsValue(data))
      } catch (e) {
        this.$notification['error']({
          message: 'Error',
          description: 'Error receiving data',
        });
      } finally {
        this.$vs.loading.close()
      }
    },
    limitationDate(e) {
      this.active_Limitations = e.target.checked
      this.form.resetFields('limitation_date')
      // TODO(pooya): Kept the old code for reference. If this continues to
      // function properly, then completely remove the old implementation.
      // if (e.target.checked) {
      //   this.active_Limitations = true
      // } else {
      //   this.active_Limitations = false
      //   this.form.resetFields('limitation_date')
      // }
    },
    async getContacts() {
      const {data} = await axios.post('/contact/query/',{limit:100})
      this.contacts = data.rows
    },
    async getUsers() {
      const {data} = await axios.get('/account/list/')
      this.users = data
    },
    handleChange(e) {
      this.is_show_budget = e.target.checked
      this.updatePanelHeight('billable', e.target.checked)
      if (!e.target.checked) {
        this.has_notify_budget = false
      }
    },
    handleSelectBillingType(type){
      //type === '1' ? this.check_billing_type = true : this.check_billing_type = false
      this.check_billing_type = type
      this.updatePanelHeight('billable', true)
    },

    handleChangeNotifications(e) {
      this.has_notify_budget = e.target.checked
      this.updatePanelHeight('billable', e.target.checked)
    },

    onRelatedContactAdded() {
      this.relations.push({relationship: null, contact: null})
      this.updatePanelHeight('contacts', true)
    },

    onCustomRateAdded() {
      this.hourly_rates.push({ user: null, rate: null })
      this.updatePanelHeight('billable', true)
    },

    removeRelatedContact(index, relations, relation, related_content) {
      this.removeItem(index, relations, (relation) ? relation.id : undefined, related_content, 'relations')
      this.updatePanelHeight('contacts', false)
    },

    removeCustomRate(index, hourly_rates, hourly, new_rate) {
      this.removeItem(index, hourly_rates, (hourly) ? hourly.id : undefined, new_rate, 'hourly_rates',`hourly_rates[${index}].user`)
      this.updatePanelHeight('billable', false)
    },

    onMatterIsBillableChanged(e) {
      this.updatePanelHeight('billable', true)
    },

    onNotificationLimitChanged(e) {
      this.updatePanelHeight('billable', true)
    },

    onNotificationRecipientsChanged(e) {
      this.updatePanelHeight('billable', true)
    },

    onMatterBudgetChanged(e) {
      this.updatePanelHeight('billable', true)
    },

    onAmountChanged(e) {
      this.updatePanelHeight('billable', true)
    },

    onContactContactsChanged(e) {
      this.updatePanelHeight('contacts', false)
    },

    onContactRelationshipChanged(e) {
      this.updatePanelHeight('contacts', false)
    },

    onContactsPanelResized() {
      const element = document.querySelector(`.contacts .vs-collapse-item--content`)
      // console.log('element height', element.clientHeight, element.scrollHeight, element.style.maxHeight)
      if (element.style.maxHeight !== '0px') {
        element.style.maxHeight = `${element.scrollHeight}px`
      }
    },

    onBillingPanelResized() {
      const element = document.querySelector(`.billable .vs-collapse-item--content`)
      // console.log('element height', element.clientHeight, element.scrollHeight, element.style.maxHeight)
      if (element.style.maxHeight !== '0px') {
        element.style.maxHeight = `${element.scrollHeight}px`
      }
    },
    
    updatePanelHeight(panelName, increase) {
      if (panelName !== 'billable' && panelName !== 'contacts') {
        throw new Error(`Invalid value for panelName in updatePanelHeight(). Expected "billable" or "contacts", received "${panelName}."`)
      }
      if (typeof increase !== 'boolean') {
        throw new Error('Invalid value for increase in updatePanelHeight(). Must be a boolean value.')
      }
      
      const element = document.querySelector(`.${panelName} .vs-collapse-item--content`)
      const panelHeightDataName = (panelName === 'billable') ? 'oldBillingPanelHeight' : 'oldContactsPanelHeight'
      
      if (increase) { // Increase the height.
        this[panelHeightDataName] = element.scrollHeight
        // console.log('INCREASE: this.oldContactsPanelHeight', this[panelHeightDataName], this.oldContactsPanelHeight, element.scrollHeight)
        this.$nextTick(() => {
          // console.log('height_collapse 2', element.scrollHeight)
          element.style.maxHeight = `${element.scrollHeight}px`
        })
      } else { // Don't touch the height.
        // console.log('DONT TOUCH: this.oldContactsPanelHeight', this[panelHeightDataName], this.oldContactsPanelHeight)
        this.$nextTick(() => {
          // console.log('value 2', this[panelHeightDataName])
          element.style.maxHeight = `${this[panelHeightDataName]}px`
        })
      }
    },
  },

  computed: {
    editContact() {
      return this.$route.params && this.$route.params.id !== undefined
    }
  },

  mounted() {
    this.getContacts()
    this.getUsers()
    if (this.editContact) {
      this.editItem()
    }

    this.billingPanelResizeObserver = new ResizeObserver(this.onBillingPanelResized)
    this.billingPanelResizeObserver.observe(document.querySelector(`.billable .vs-collapse-item--content`))
    this.onBillingPanelResized()
    
    this.contactsPanelResizeObserver = new ResizeObserver(this.onContactsPanelResized)
    this.contactsPanelResizeObserver.observe(document.querySelector(`.contacts .vs-collapse-item--content`))
    this.onContactsPanelResized()
  },

  beforeUnmount() {
    this.billingPanelResizeObserver.unobserve(document.querySelector(`.billable .vs-collapse-item--content`))
    this.contactsPanelResizeObserver.unobserve(document.querySelector(`.contacts .vs-collapse-item--content`))
  },
}
</script>

<style>
  [dir] .ant-input, [dir] .ant-calendar-picker-input, [dir] .ant-select-selection {
    border-radius: 3px !important;
  }

  .ant-calendar-picker-input {
    border-radius: 3px !important;
  }

  [dir] .ant-select-selection {
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-top-width: 1.02px;
    border-radius: 3px;
    -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  .header-matter {
    margin-top: 1rem;
  }

  .vs-collapse.margin .vs-collapse-item {
    background: #fff !important;
  }

  .ant-divider.ant-divider-horizontal {
    /*background: #ccc !important;*/
  }

  .vx-card__header .vx-card__title h4 {
    color: #3A3DBE !important;
  }

  .vs-collapse {
    padding: 0 !important;
  }

  [dir] .select .ant-select-selection.ant-select-selection--single {
    border-radius: 3px !important;
  }

  .ant-message {
    z-index: 1000000000000;
  }

  .vs-collapse-item {
    cursor: default !important;
  }

  .vs-collapse-item.open-item {
    padding: 1em;
  }
  .rate_inp input{
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  /*[dir] .ant-input-group-addon{*/
  /*  border-radius: 3px !important;*/
  /*}*/
  .rate_inp .ant-input-group-addon{
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-top-right-radius: 3px !important;
    border-bottom-right-radius: 3px !important;
  }
  .has-success.has-feedback .ant-form-item-children-icon {
    /*color: #3A3DBE !important;*/
    z-index: 0;
  }
  .ant-input-group-wrapper .ant-input{
    border-top-left-radius: 3px !important;
    border-bottom-left-radius: 3px !important;
  }
  .vs-card--content{
    margin-bottom: 0 !important;
  }
  .divider-matter.ant-divider {
    background: #ccc !important;
  }
</style>
